// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"DashboardBreadcrumbs_breadcrumbs__WAnIb"};